import { NotpImageClass } from '../../components/descope-notp-image/NotpImageClass';

const vars = NotpImageClass.cssVarList;

const logo = {
  [vars.fallbackUrl]: 'url(https://imgs.descope.com/components/notp-placeholder.svg)',
};

export default logo;
export { vars };
